var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "outboundcalling-card"
  }, _vm._l(_vm.list, function ({
    icon,
    title,
    desc
  }) {
    return _c("div", {
      key: title,
      staticClass: "list"
    }, [_c("img", {
      attrs: {
        src: icon,
        alt: ""
      }
    }), _c("h4", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };